import { useEffect, useState } from 'react';
import { toolbarActive, updateLogoSelect } from '../../js/webGL';

export function useLogoFuncs(logos) {
  const [activeIdx, setActiveIdx] = useState(-1);

  const setCurrentLogo = (logo, ratio) => {
    for (let i = 0; i < window.decals.length; i += 1) {
      if (logo.Id !== window.decals[i].logo.Id) continue;
      window.currentLogo = window.decals[i].logo;
      window.currentLogo.Rotate = 0;
      window.currentLogo.ratio = ratio;
      return true;
    }
    return false;
  };

  const handleOnClick = (index, ratio) => {
    setActiveIdx(index);
    window.isSelectedLogoTool = index !== -1;
    var logo = logos[index];
    if (setCurrentLogo(logo, ratio)) {
      updateLogoSelect(window.currentLogo);
      return;
    }
    logo.Rotate = 0;
    logo.ratio = ratio;
    updateLogoSelect(logo);
  };

  // Register global function to reset active index when logo is deleted
  useEffect(() => {
    window.resetActiveLogoIndex = () => {
      setActiveIdx(-1);
    };

    // Register global function to active logo in list by logo Id
    window.setActiveLogoIndexById = (logoId) => {
      if (!logos || !logoId) return;
      // Find logo index in logos array by Id
      const logoIndex = logos.findIndex((logo) => logo && logo.Id === logoId);
      if (logoIndex !== -1) {
        setActiveIdx(logoIndex);
      }
    };

    return () => {
      delete window.resetActiveLogoIndex;
      delete window.setActiveLogoIndexById;
    };
  }, [logos]);

  // Auto-active first logo on model when logos and decals are loaded
  useEffect(() => {
    if (!logos || logos.length === 0) return;
    if (!window.decals || window.decals.length === 0) return;
    if (activeIdx !== -1) return; // Already has active logo

    // Find first logo that exists on model
    for (let i = 0; i < logos.length; i++) {
      const logo = logos[i];
      if (logo && logo.Id) {
        const logoOnModel = window.decals.find(
          (d) => d.logo && d.logo.Id === logo.Id && d.logo.IsText !== true,
        );
        if (logoOnModel) {
          // Found logo on model, active it
          setActiveIdx(i);
          window.currentLogo = logoOnModel.logo;
          updateLogoSelect(window.currentLogo);
          break;
        }
      }
    }
  }, [logos]);

  // Watch for logo deletion and reset active index
  useEffect(() => {
    const checkLogoDeleted = () => {
      // If currentLogo is null and we have an active index, check if the logo still exists
      if (window.currentLogo === null && activeIdx !== -1) {
        // Check if the active logo still exists in decals
        const activeLogo = logos[activeIdx];
        if (activeLogo) {
          const logoExists = window.decals.some(
            (d) => d.logo && d.logo.Id === activeLogo.Id && d.logo.IsText !== true,
          );
          if (!logoExists && toolbarActive.value === 'logo') {
            // Logo was deleted, reset active index
            setActiveIdx(-1);
          }
        } else {
          setActiveIdx(-1);
        }
      }
    };

    // Check periodically for logo deletion (fallback)
    const interval = setInterval(checkLogoDeleted, 100);

    return () => clearInterval(interval);
  }, [activeIdx, logos]);

  return { activeIdx, handleOnClick };
}
